import { useContext } from 'react';

import { ConsentContext } from './consentContext';
import type { ConsentContextValue } from '../ui/ConsentProvider';

/**
 * Доступ к решению о необязательных технологиях.
 *
 * Бросает вне провайдера, а не возвращает «всё запрещено»: молчаливый запрет
 * скрыл бы ошибку сборки, при которой провайдер потерялся, — и баннер
 * согласия перестал бы показываться, когда он обязателен.
 */
export function useConsent(): ConsentContextValue {
  const value = useContext(ConsentContext);
  if (value === null) {
    throw new Error('useConsent must be used inside ConsentProvider');
  }
  return value;
}
